
    import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
    import api from "@/api";
    import store from "@/store";

    @Component({
        name: "productConfig",
        components: {}
    })

    export default class extends Vue {
        // 字典
        config: any = store.state.system.config

        // tab切换
        activeName='1'
        handleClick(tab: any, event: any) {
            console.log('handleClick', tab, event);
        }

        // 选择支付方式，下边联动
        showType = 1
        choseType(type: any) {
            this.showType = type
            this.payForm.pay_channel = ''
            this.showOutorgPayChannel(type)
        }
        showOutorgPayChannel(type: any) {
            if(type == 2) {
                this.outorg_pay_channel = {}
                this.outorg_pay_channel['third'] = this.config.outorg_pay_channel['third']
            } else {
                this.outorg_pay_channel = {...this.config.outorg_pay_channel}
                delete this.outorg_pay_channel['third']
            }
        }

        // 支付通道
        outorg_pay_channel: any = {}


        // 查看参数
        cs = {}
        csDialog = false
        list: any = []
        setPayCS(row: any) {
            this.cs = row
            this.list = [
                {
                    name: "银行名称",
                    value: row.bank,
                },
                {
                    name: "开户行",
                    value: row.bank_branch,
                },
                {
                    name: "账户名称",
                    value: row.bankname,
                },
                {
                    name: "收款账号",
                    value: row.bank_account,
                },
            ]
            this.csDialog = true
        }

        // 删除
        delDialog = false
        product = {}
        delId = ''
        del(id: any) {
            this.delId = id
            api.getProductPaytype({id}).then((res: any) => {
                if(res instanceof Array) {
                    // 如果没产品 直接删除
                    this.$confirm('是否删除该项?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(res => {
                        api.post('A7010', {id}).then(res => {
                            this.$message.success('操作成功')
                            this.getPay()
                        })
                    })
                    return
                }
                this.product = res
                this.delDialog = true
            })

        }
        cancleDel() {
            this.delDialog = false
        }
        sureDel() {
            api.post('A7010', {id: this.delId}).then(res => {
                this.$message.success('操作成功')
                this.delDialog = false
                this.getPay()
            })

        }

        // 基础配置
        ruleForm: any = {
            name: '',
            alias: '',
            type: '',
            attribute: '',
            desc: '',
            logo: ''
        }

        getOrgInfo() {
            api.post('A7017', {id: this.$route.query.id}).then(res => {
                this.ruleForm = {
                    name: res.name,
                    alias: res.alias,
                    type: res.type,
                    attribute: res.attribute,
                    desc: res.desc,
                    config: res.config,
                    logo: res.logo
                }
                this.limitForm = {
                    id: res.id,
                    quota: res.surplus_quota,
                    start_at: res.start_at,
                    end_at: res.end_at,
                }
                this.limitDate = [res.start_at, res.end_at]
            })
        }
        submitForm() {
            if(!this.ruleForm.name) {
                this.$message.warning('机构全称不能为空')
                return
            }
            if(!this.ruleForm.alias) {
                this.$message.warning('机构简称不能为空')
                return
            }
            if(!this.ruleForm.type) {
                this.$message.warning('请选择机构类别')
                return
            }
            if(!this.ruleForm.attribute) {
                this.$message.warning('请选择机构属性')
                return
            }
            this.ruleForm.id = this.$route.query.id
            api.post('A7003', this.ruleForm).then(res => {
                this.$message.success('操作成功')
                this.activeName = '2'
            })

        }

        // 渠道配置
        qudaoForm = {
            region: '',
            baohan: '',
        }

        // 支付方式
        btnloading = false
        payDialog = false
        payForm: any = {
            name: '',
            type: '',
            pay_channel: '',
            bank: '',
            bank_branch: '',
            bankname: '',
            bank_account: '',
            sdk: ''
        }

        setPay(row?: any) {
            if(row.id) {
                this.payForm = {
                    id: row.id,
                    name: row.name,
                    type: row.type,
                    pay_channel: row.pay_channel,
                    bank: row.bank,
                    bank_branch: row.bank_branch,
                    bankname: row.bankname,
                    bank_account: row.bank_account,
                    sdk: row.sdk
                }
                this.showType = row.pay_channel == 'third' ? 2 : 1
                this.showOutorgPayChannel(this.showType)
                this.payDialog = true
                return
            }
            this.payForm = {
                id: '',
                name: '',
                type: '',
                pay_channel: '',
                bank: '',
                bank_branch: '',
                bankname:  '',
                bank_account: '',
                sdk: ''
            }
            this.payDialog = true
        }
        canclePay() {
            this.payDialog = false
        }
        savePay() {
            if(!this.payForm.name) {
                this.$message.warning('请输入支付方式名称')
                return
            }
            if(!this.payForm.type) {
                this.$message.warning('请选择支付类型')
                return
            }
            if(!this.payForm.pay_channel) {
                this.$message.warning('请选择支付通道')
                return
            }
            if(this.showType == 1) {
                if(!this.payForm.bank) {
                    this.$message.warning('请输入银行名称')
                    return
                }
                if(!this.payForm.bank_branch) {
                    this.$message.warning('请输入开户行')
                    return
                }
                if(!this.payForm.bankname) {
                    this.$message.warning('请输入账户名称')
                    return
                }
                if(!this.payForm.bank_account) {
                    this.$message.warning('请输入收款账号')
                    return
                }
                this.payForm.sdk = ''
            } else {
                this.payForm.bank = ''
                this.payForm.bank_branch = ''
                this.payForm.bankname = ''
                this.payForm.bank_account = ''
            }

            this.payForm.org_id = this.$route.query.id
            this.btnloading = true
            api.post(this.payForm.id ? 'A7008' : 'A7006', this.payForm).then(res => {
                this.$message.success('操作成功')
                this.payDialog = false
                this.getPay()
            }).finally(() => {
                this.btnloading = false
            })

        }
        paySearch: any = {
            org_id: '',
            pagination:{
                page:0,
                pageSize:20
            }
        }
        payData = []
        payTotal = 0
        getPay() {
            this.paySearch.org_id = this.$route.query.id
            api.post('A7007', this.paySearch).then(res => {
                this.payData = res.list
                this.payTotal = res.total
            })
        }

        // 变更支付状态
        setStatus(id: any, status: any) {
            api.post('A7009', {id, status}).then(res => {
                this.$message.success('操作成功')
                this.getPay()
            })
        }


        // 产品方案
        planDialog = false
        planForm: any = {
            name: '',
            config: {}
        }
        planConfig = ''
        producteData = []
        productTotal = 0
        productSearch: any = {
            org_id: '',
            pagination: {
                page: 0,
                pageSize: 20
            }
        }
        getProduct() {
            this.productSearch.org_id = this.$route.query.id
            api.post('A7011', this.productSearch).then(res => {
                this.producteData = res.list
                this.productTotal = res.total
            })
        }
        setPlan(row?: any) {
            this.planForm = {
                name: '',
                config: {}
            }
            if(row) {
                this.planConfig = JSON.stringify(row.config)
                this.planForm = {
                    id: row.id,
                    name: row.name,
                    config: row.config
                }
            }

            this.planDialog = true
        }
        canclePlan() {
            this.planDialog = false
        }
        savePlan() {
            if(!this.planForm.name) {
                this.$message.warning('请输入方案名称')
                return
            }
            if(!this.planConfig) {
                this.$message.warning('请输入方案参数')
                return
            }
            this.planForm.config = (new Function("return " + this.planConfig))()
            let obj = {...this.planForm}
            if(this.planForm.id) {
                obj['id'] = this.planForm.id
            } else {
                obj['org_id'] = this.$route.query.id
            }
            api.post(this.planForm.id ? 'A7013' : 'A7012', obj).then(res => {
                this.$message.success('操作成功')
                this.planDialog = false
                this.getProduct()
            })

        }
        delPlanId = ''
        plan = {}
        delPlan(id: any) {
            this.delPlanId = id

            api.getProductPlan({id}).then(res => {
                if(res instanceof Array) {
                    // 如果没产品 直接删除
                    this.$confirm('是否删除该项', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        api.post('A7014', {id}).then(res => {
                            this.$message.success('操作成功')
                            this.getProduct()
                        })
                    })
                    return
                }
                this.plan = res
                this.delPlanDialog = true
            })
        }
        delPlanDialog = false
        sureDelPlan() {
            api.post('A7014', {id: this.delPlanId}).then(res => {
                this.$message.success('操作成功')
                this.delPlanDialog = false
                this.getProduct()
            })
        }
        cancleDelPlan() {
            this.delPlanDialog = false
        }

        //日志
        logDialog = false
        logList = []
        logTotal = 0
        logSearch = {
            id: '',
            pagination: {
                page: 0,
                pageSize: 20
            }
        }
        toLog(id: any) {
            this.logSearch.id = id
            api.post('A7015', this.logSearch).then(res => {
                this.logList = res.list
                this.logTotal = res.total
                this.logDialog = true
            })
            this.logDialog = true
        }

        // 运营配置
        limitForm: any = {}
        limitDate: any = []
        saveLimit() {
            api.post('A7016', this.limitForm).then(res => {
                this.$message.success('操作成功')
            })
        }

        activated() {

            let { id} = this.$route.query
            this.getOrgInfo()
            this.getPay();
            this.getProduct()

        }

    }
